/**
 * The three kinds of розрахунковий документ a ПРРО issues. The values are the
 * strings the rest of the code has always used — a translation key suffix, a
 * filter value, a badge tone key — so nothing about the wire format changes.
 */
export enum ReceiptTypeEnum {
  Sale = "sale",
  Return = "return",
  Service = "service",
}

export enum PaymentMethodEnum {
  Cash = "cash",
  Card = "card",
}
